module.exports = __webpack_public_path__ + "img/report-10.46458142.jpg";